<template>
    <div class="indent">
        <div class="banner">
        </div>
        <div class="wrapper">
            <div style="text-align:center;font-weight:bold;font-size:20px">乐分享软件  注册使用协议</div>
            <div class="space2">
                欢迎申请使用徐州乐分享软件科技有限公司（以下简称“乐分享软件”）提供的乐分享题库、组卷和考试系列产品（以下简称“本软件”），系列产品包括乐分享云题库、乐分享题库网页端、乐分享题库电脑客户端、乐分享考试网页端、乐考试移动端。您（以下或简称“用户”）在使用乐分享软件提供的各项服务（以下简称“本服务”）之前，请您务必审慎阅读、充分理解并选择接受或不接受本服务协议（以下简称“本协议”）各条款内容，包括但不限于免除或者限制乐分享软件责任的条款。未成年人应在法定监护人陪同下阅读。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉相关服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议可由乐分享软件随时更新，更新后的协议条款一旦公布即代替旧协议条款，恕不再另行通知，用户可在乐分享软件官网查阅最新版协议条款。在乐分享软件修改本协议条款后，如果用户不接受修改后的条款，请立即停止使用乐分享软件提供的服务，用户继续使用乐分享软件提供的服务将被视为已接受了修改后的协议。
            </div>
            <div class="space2">
                本协议内容同时包括乐分享软件可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，用户同样应当遵守。
            </div>
            <div class="title">
                一、内容
            </div>
            <div class="space2">
                本软件所包含的所有文字、图标、用户界面、可视界面、图片、商标、标识（合称为“内容”），包括但不限于该等内容的设计、结构、选择、协调、表达、界面外观及排序等，均属乐分享软件或其他权利人所有，且受著作权法、专利法、商标法以及各类其他知识产权法的保护。 除本用户协议明确规定外，未经乐分享软件事先明确书面同意，您不得为出版或发行或为任何其他商业目的以任何方式将本软件的任何部分及任何内容复制、再制、重印、上传、发布、公开展示、编码、反编译、翻译、传输或散布至任何其他终端、网站或其他媒介。 您同意授予乐分享软件非排他性、不可转让、免费的权利在合理商业使用范围内使用上述所有数据。
            </div>
            <div class="title">
                二、软件的获取
            </div>
            <div class="space2">
                您可以从得到乐分享软件的官网或者乐分享软件授权的第三方获取本软件，如果您从未经乐分享软件授权的第三方获取本软件或与本软件名称相同的安装程序，乐分享软件无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。
            </div>
            <div class="title">
                三、软件的更新
            </div>
            <div class="space2">
                为了改善用户体验、完善服务内容，乐分享软件将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。
            </div>
            <div class="space2">
                为了保证本软件及服务的安全性和功能的一致性，乐分享软件有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。本软件新版本发布后，旧版本的软件可能无法使用。乐分享软件不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。
            </div>
            <div class="space2">
                乐分享软件直接提供服务的软件版本对所有注册用户免费升级软件到最新版。对于客户购买安装到客户服务器上的所有软件的升级以乐分享软件与客户签订的协议的规定为准。
            </div>
            <div class="title">
                四、账户管理
            </div>
            <div>
                用户必须：
            </div>
            <div class="space2">
                1)购置设备，包括个人电脑一台、调制解调器一个及配备上网装置。
            </div>
            <div class="space2">
                2)个人上网和支付与此服务有关的电话费用、网络费用。
            </div>
            <div>
                用户同意：
            </div>
            <div class="space2">
                1)提供及时、详尽及准确的个人资料。
            </div>
            <div class="space2">
                2)不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料将引用为注册资料。
            </div>
            <div class="space2">
                3)用户同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》等有关计算机及互联网规定的法律和法规、实施办法。用户应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。
            </div>
            <div class="space2">
            用户注册成为本软件用户即可获得一个 ID（以下或称“帐户”），本软件提供的某些功能或服务可能要求您开立帐户。对于维护您持有帐户信息的保密性，包括您的密码，您需要妥善的进行保管。您同意一旦发生任何对您帐户或密码未经授权的使用，或者任何其他对安全的破坏情况，应当立即通知乐分享软件。

            </div>
            <div class="space2">
            乐分享软件帐号的所有权归乐分享软件所有，您完成申请注册手续后，获得乐分享软件帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。

            </div>
            <div class="space2">

            本条及本协议其他条款未明示授权的其他一切权利仍由乐分享软件保留，您在行使这些权利时须另外取得乐分享软件的书面许可。乐分享软件如果未行使前述任何权利，并不构成对该权利的放弃。 用户应遵守本协议的各项条款，正确、适当地使用本服务，如用户违反本协议中的任何条款，乐分享软件有权依据协议中断或终止对违约用户帐号提供服务。
            </div>
            <div class="space2">

            如果乐分享软件发现或收到他人举报或投诉用户违反本协议约定的，乐分享软件有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并有权公告处理结果。
            </div>
            <div class="title">
            五、用户个人信息保护

            </div>
            <div class="space2">
            一旦注册成功成为本软件用户，您将得到一个密码和账号。如果您不保管好自己的账号和密码安全，将对因此产生的后果负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。

            </div>
            <div class="space2">
            用户有权利要求本软件对用户的账号、密码、用户个人信息保密，但因以下情况本软件基于诚信原则具有披露用户信息的义务：

            </div>
            <div>
            1.	（1）依照相关法律、法规，配合相关司法程序履行信息披露义务；<br>
            2.	（2）在紧急情况下为维护社会公共利益及其他更大法益而必须做出的信息披露行为；<br>
            3.	（3）为维护本软件知识产权而必须进行的法律手段；<br>
            4.	（4）其他法律、法规要求的；

            </div>
            <div class="title">
            六、用户行为规范

            </div>
            <div class="space2">

            用户在使用本软件时，必须遵守中华人民共和国相关法律法规及相关国际公约的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为:
            </div>
            <div class="space2">
            (1) 用户不得上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：

            </div>
            <div>

            •	1) 违反中华人民共和国宪法确定的基本原则的；<br>
            •	2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
            •	3) 损害国家荣誉和利益的；<br>
            •	4) 煽动民族仇恨、民族歧视、破坏民族团结的；<br>
            •	5) 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
            •	6) 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
            •	7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
            •	8) 侮辱或者诽谤他人，侵害他人合法权益的；<br>
            •	9) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；<br>
            •	10) 以非法民间组织名义活动的；<br>
            •	11) 不符合应当遵守法律法规、社会主义制度、国家利益、公民合法利益、公众秩序、社会道德风尚和信息真实性等“七条底线”要求的；<br>
            •	12) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；<br>
            •	13）进行商业广告行为的；<br>
            •	14）传输任何教唆他人构成犯罪行为的资料；<br>
            •	15）传输对国内不利条件和涉及国家安全的资料；
            </div>
            <div class="space2">
            (2)用户不得利用“ ID”或本服务制作、上载、复制、发布、传播如下干扰本软件正常运营，以及侵犯其他用户或第三方合法权益的内容：

            </div>
            <div>

            •	1) 含有任何性或性暗示的；<br>
            •	2) 含有辱骂、恐吓、威胁内容的；<br>
            •	3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；<br>
            •	4) 涉及他人隐私、个人信息或资料的；<br>
            •	5) 侵害他人一般人格权、名誉权、肖像权、知识产权、商业秘密等合法权利的内容；<br>
            •	6) 含有其他干扰本软件正常运营和侵犯其他用户或第三方合法权益内容的信息。
            </div>
            <div class="space2">
            (3) 用户不得为任何非法目的而使用软件，不利用本软件从事以下活动：

            </div>
            <div>
            •	1) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；<br>
            •	2) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br>
            •	3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br>
            •	4) 故意制作、传播计算机病毒等破坏性程序的；<br>
            •	5) 其他危害计算机信息网络安全的行为。

            </div>
            <div class="space2">

            (4) 用户不得利用本软件从事进行如下行为：
            </div>
            <div>

            •	1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义；<br>
            •	2) 强制、诱导其他用户关注、点击链接页面或分享信息；<br>
            •	3) 虚构事实、隐瞒真相以误导、欺骗他人的；<br>
            •	4) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；<br>
            •	5) 未经乐分享软件书面许可利用乐分享软件APP帐号和任何功能进行推广或互相推广的；<br>
            •	6) 利用技术手段批量建立虚假帐号；<br>
            •	7)私自将乐分享软件公司的资源内容复制发布、编辑出版、转卖或提供给任何第三方组织或个人，或将乐分享软件公司的试题试卷资源私自上传到除乐分享软件之外的其他网站、社区、论坛；<br>
            •	8)采用技术手段在乐分享软件进行高频次的访问、长期逐页逐项抓取（下载）页面内容；<br>
            •	9)通过非正常手段在乐分享软件上组卷，下载、访问等超出正常教学使用或其他非正常使用的操作等。<br>
            •	10) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；<br>
            •	11) 其它违反法律法规规定、侵犯其他用户合法权益、干扰本软件正常运营的行为。
            </div>
            <div class="space2">

            (5) 凡用户昵称中出现如下信息者（包括但不限于），乐分享软件有权进行屏蔽、锁定，甚至注销：
            </div>
            <div>

            •	1) 使用严重违反国家法律法律及风序良俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；<br>
            •	2) 使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；<br>
            •	3) 使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；<br>
            •	4) 含性别歧视、种族歧视、地域歧视等信息的昵称；<br>
            •	5) 含自侮辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；<br>
            •	6) 含易产生歧义、引起他人误解的信息的昵称；<br>
            •	7) 未获得“乐分享软件”官方正式许可而使用带有“乐分享软件”相关名称的昵称；<br>
            •	8) 与“乐分享软件”老师、助教及社区管理人员的昵称近似或雷同，并可能引起混淆或纠纷的；<br>
            •	9) 带有明显广告性质的昵称；<br>
            •	10) 带有其它法律法规以及论坛禁止规则中所包含信息的昵称。
            </div>
            <div class="space2">

            (6) 用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括但不限于为解决争议因此产生的律师费、诉讼费，您同意赔偿乐分享软件与合作公司、关联公司上述费用，并使之免受损害。对此，乐分享软件有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收 ID、追究法律责任等措施。 对恶意注册 ID 或利用 ID 进行违法活动，捣乱、骚扰、欺骗其他用户以及其他违反本协议的行为，乐分享软件有权回收其帐号。同时，乐分享软件会视司法部门的要求协助调查。
            </div>
            <div class="space2">

            (7) 用户须对自己在使用本软件过程中的行为承担法律责任，自行对传送信息的真实性、合法性、无害性、准确性、有效性等全权负责。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在本软件首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，乐分享软件会对用户进行追偿。
            </div>
            <div class="space2">

            (8)用户应当确保在本软件下载的资源仅限于个人教学、学习使用，不得将本软件资源转载、复制、上传到第三方媒介获取利益，一经发现，本软件有权要求移除侵权内容并赔偿损失；
            </div>
            <div class="space2">

            (9)用户应当确保自己上传的资源没有侵犯他人的合法权益，所有因用户本人上传资源引发的纠纷，均由用户本人承担责任。他人提出投诉并提供相关证据后，乐分享软件有权直接移除侵权内容并不需要通知上传用户本人。
            </div>
            <div class="space2">
            (10)用户不得使用以下方式登录本软件或破坏本软件的服务，对本软件造成损失的，由用户承担相关法律责任：

            </div>
            <div>
            •	1) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录本软件；<br>
            •	2）通过任何方式对本软件内部结构造成或可能造成不合理或不合比例的重大负荷的行为；<br>
            •	3）通过任何方式干扰或试图干扰本软件的正常工作或在软件上进行的任何违法活动。<br>

            </div>
            <div class="title">
            七.用户注意事项

            </div>
            <div class="space2">
            您理解并同意：为了向您提供有效的服务，本软件会利用您终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。

            </div>
            <div>

            您理解并同意乐分享软件将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，乐分享软件并不能就此提供完全保证，包括但不限于以下情形：
            </div>
            <div>
            •	1) 乐分享软件不对您在本软件及服务中相关数据的删除或储存失败负责；<br>
            •	2) 乐分享软件有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本软件及服务中的相关数据；<br>
            •	3) 如果您停止使用本软件及服务或服务被终止或取消，乐分享软件可以从服务器上永久地删除您的数据。服务停止、终止或取消后，乐分享软件没有义务向您返还任何数据。

            </div>
            <div class="space2">

            用户在使用本软件及服务时，须自行承担如下来自乐分享软件不可掌控的风险内容，包括但不限于：
            </div>
            <div>
            •	1) 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；<br>
            •	2) 用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；<br>
            •	3) 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；<br>
            •	4) 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的乐分享软件APP登录失败、资料同步不完整、页面打开速度慢等风险。

            </div>
            <div class="space2">

            您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。
            </div>
            <div class="title">
            八、免责声明

            </div>
            <div class="space2">

            乐分享软件会致力于向您提供安全、稳定的优质服务。但是，乐分享软件不作任何类型的担保，乐分享软件不承诺本软件的任何内容、服务或功能无任何错误或不中断，或者您对本软件的使用将产生特定结果。本软件及其内容是基于“现状”且“可获得”而提供。本软件提供的所有信息可不经通知而变更。乐分享软件不作任何明示或默示保证，包括任何正确性、非侵权、适销性及适用性的保证。对于任何与您对本软件和/或乐分享软件服务的使用有关的任何第三方的作为、不作为和行为，乐分享软件不承担责任。如果对本软件或任何内容有任何不满意，您可以停止使用本软件或任何该内容。
            </div>
            <div class="space2">

            上述免责声明适用于因任何不履行、错误、疏忽、中断、删除、缺陷、操作或传输迟延、病毒、通信线路故障、失窃或破坏或未经授权、篡改或使用（无论是违约、侵权、过失或任何其他诉因）而造成的任何损害、责任或伤害。
            </div>
            <div class="space2">
            乐分享软件保留在任何时候不经通知进行以下任何行为的权利：（1）基于任何原因，修改，中止或终止本软件或其任何部分的运行或访问；（2）修改或变更本软件或其任何部分及适用政策或条款；以及（3）在进行任何定期或非定期维护、错误纠正或其他变更所必需时，中断本软件或其任何部分的运行。

            </div>
            <div class="title">
            九、违反本用户协议

            </div>
            <div class="space2">

            您同意，若乐分享软件认为您违反了本用户协议或可能与您使用本软件相关的其他协议或指引，乐分享软件可以终止您使用本软件的权限。
            </div>
            <div class="space2">
            您同意，乐分享软件可自行决定且无需提前通知，因下列原因终止您访问本软件的权限，包括（但不限于）：（1）应政府部门和司法机关的要求；（2）本软件或本软件提供的任何服务的中止或重大修改；或 （3）不可预期的技术问题。

            </div>
            <div class="space2">

            若因您违反本用户协议致使乐分享软件对您提起法律诉讼，除法律授予乐分享软件的任何其他救济外，乐分享软件有权从您处获得且您同意支付所有合理的律师费及该等诉讼费用。您同意，因对本使用协议的任何违反导致乐分享软件终止您使用本软件的权限，乐分享软件概不对您或任何第三方承担责任。
            </div>
            <div class="title">
            十、知识产权

            </div>
            <div class="space2">
            （1）本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及本软件包含的任何文字、图表、音频、视频或软件（包括但不限于软件中包含的图表、动画、音频、视频、界面设计、版面框架、数据和程序、代码、文档）等信息或材料均受著作权法、商标法、专利法或其它法律法规、国际条约的保护，未经相关权利人书面同意，用户不得以任何方式实施、使用或转让该等知识产权、信息或材料。

            </div>
            <div class="space2">
            （2）本协议未授予用户使用乐分享软件任何商标、服务标记、标识、域名和其他显著品牌特征的权利。 除本协议明确允许的以外，用户不得以任何形式或任何方式对乐分享软件服务部分或全部内容进行修改、出租、租赁、出借、出售、分发、复制、创作衍生品或用于任何商业用途。 用户在乐分享软件发布的信息不得侵犯任何第三人的知识产权，未经相关权利人之事先书面同意，用户不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。

            </div>
            <div class="space2">

            （3）若您认为您的知识产权或其他合法权益被侵犯，请与乐分享软件联系。
            </div>
            <div class="space2">

            （4）鉴于本软件属于网络服务提供者，本软件对用户上传的资源不负事先审查的义务，任何单位或个人认为本软件内容涉嫌侵犯其著作权的，应当及时向本公司提出以下材料：
            </div>
            <div class="space2">

            1）书面权利通知；
            </div>
            <div class="space2">
            2）本人身份证明；

            </div>
            <div class="space2">

            3）著作权权属证明；
            </div>
            <div class="space2">

            4）详细侵权情况证明；
            </div>
            <div class="space2">

            5）侵害著作权作品在本软件的所在位置；
            </div>
            <div class="space2">

            6）著作权人的必要的真实的联系方式；
            </div>
            <div class="space2">

            7）对于自身提供的上述资料真实性的书面保证。
            </div>
            <div class="space2">

            乐分享软件在收到上述法律文件后，将会依法尽快删除相关内容；
            </div>
            <div class="space2">

            （5）本软件对于任何经由搜索、链接、下载或其它途径所获得的有关本软件的任何内容、信息或广告，不声明或保证其正确性或可靠性。对依赖本软件资料所引致的任何意外本软件概不负责，亦不承担任何经济和法律责任；
            </div>
            <div class="space2">
            （6）用户通过本软件发表的一切原创信息，包括但不限于试题、课件、教案、文章、图片、FLASH、影音文件等，其版权归本公司及该用户共同所有。本软件有权在网站自行开设或与合作伙伴共同开设的其他专栏内摘录、转载和引用此类信息全部的或部分的内容；

            </div>
            <div class="space2">
            （7）任何传播媒体转载、摘编本软件刊登、发布的作品，必须按法律规定向著作权人或本软件支付报酬并注明出处，且不得超过本软件刊登、转载该作品的范围；著作权人声明或者本软件受著作权人授权声明不得转载、摘编其作品的，任何人不得擅自转载、摘编，否则必须承担一切法律后果；

            </div>
            <div class="title">
            十一、不可抗力

            </div>
            <div class="space2">
            因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。

            </div>
            <div class="title">
            十二、保密责任

            </div>
            <div class="space2">

            双方保证在对讨论、签订、执行本协议中所获悉的属于对方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，另一方不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
            </div>
            <div class="title">

            十三、争议解决
            </div>
            <div class="space2">

            本用户协议及您与乐分享软件的关系适用于中华人民共和国大陆地区法律，但不包括其冲突法规范。您和乐分享软件同意服从乐分享软件所在地法院的司法管辖。
            </div>
            <div class="title">
                
            十四、其他
            </div>
            <div class="space2">

            若本协议的任何条款被享有合法管辖权的法院裁定为无效或不可执行，则该等条款应在最低必要范围内予以限制或排除，并以最能体现本用户协议意图的新条款予以替换，以使本用户协议继续完全有效。
            </div>
            <div class="space2">

            本用户协议构成您与乐分享软件之间与您使用本软件相关的整体协议，并在此取代及取消您与乐分享软件之间先前存在的与该等使用相关的任何书面或口头协议或理解。
            </div>
            <div class="space2">

            本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
            </div>
            <div class="title">
            十五、联系方式

            </div>
            <div class="space2">

            如果您对本协议有任何疑问、意见或建议，通过以下方式与我们联系：18652255099, （周一至周日10:00-22:00）。
            </div>


        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    }
}
</script>
<style lang="less">
    .indent{
        .banner{
            position: fixed;
            top: 0;
            left: 0;
            height: 60px;
            width: 100%;
            background: #198AF7;
        }
        .wrapper{
            padding-top: 80px;
            padding-bottom: 20px;
            width: 1200px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 30px;
            .space2{
                text-indent: 2em;
            }
            .title{
                font-weight: bold;
                margin-top: 10px;
            }
        }
    }
</style>